import React, { useState } from 'react';
import { SCUIContent } from '../../../atomic/organisms';
import { Grid, TextField } from '@mui/material';
import { SCUIButton, SCUILoadingLinear } from '../../../atomic/atoms';
import { SCUIBreadCrumb } from '../../../atomic/molecules';
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from '@mui/icons-material/Search';
import GoalQuery from '../../../services/query/goal/GoalQuery.services';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';

export const GoalStatusSending = () => {
    const [shippingListNos, setShippingListNos] = useState('');
    const [loading, setLoading] = useState<boolean>(false);
    const { t } = useTranslation();

    const SendToGoal = (shippingNumbers: any) => {
        setLoading(true);
        try {
            const shippingList = shippingNumbers
                .split(/[\n,]/)
                .filter((x: any) => x !== '' && x !== null && x !== undefined)
                .map((x: string) => x.trim().substring(0, 13))
                .map((x: string) => parseInt(x, 10));

            if (shippingList.length === 0) {
                Swal.fire({
                    icon: 'warning',
                    title: t('general.warning'),
                    text: t('general.pleaseEnterValue'),
                    confirmButtonText: t('general.yes'),
                });
                setLoading(false);
                return;
            }

            const req: { ShipmentNumber: string[] } = { ShipmentNumber: shippingList };

            GoalQuery.SendToGoal(req)
                .then((response: any) => {
                    if (response.statuscode === 200) {
                        if (response.model?.data?.result && response.model.data.result.includes('could not be sent')) {
                            Swal.fire({
                                icon: 'error',
                                title: t('general.error'),
                                text: response.model.data.result,
                                confirmButtonText: t('general.accept'),
                            });
                        } else {
                            Swal.fire({
                                icon: 'success',
                                title: t('general.success'),
                                text: t('general.success'),
                                confirmButtonText: t('general.accept'),
                            });
                            setShippingListNos('');
                        }
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: t('general.error'),
                            text: response.message || t('general.error'),
                            confirmButtonText: t('general.accept'),
                        });
                    }
                    setLoading(false);
                })
                .catch((error: any) => {
                    console.error('Error during SendToGoal:', error);
                    Swal.fire({
                        icon: 'error',
                        title: t('general.error'),
                        text: t('general.error'),
                        confirmButtonText: t('general.accept'),
                    });
                    setLoading(false);
                });
        } catch (error) {
            console.error('Error during SendToGoal:', error);
            Swal.fire({
                icon: 'error',
                title: t('general.error'),
                text: t('general.error'),
                confirmButtonText: t('general.accept'),
            });
            setLoading(false);
        }
    };

    return (
        <SCUIContent>
            <Grid>
                <SCUIBreadCrumb
                    title={t('goalStatusSending.title')}
                    componentLink={'/goal-status-sending'}
                    style={{ cursor: 'pointer' }}
                />
                <Grid
                    size={{
                        xs: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    }}
                >
                    {loading && <SCUILoadingLinear display={loading} />}
                </Grid>
                <Grid container sx={{ paddingTop: 2 }}>
                    <Grid
                        size={{
                            xs: 4,
                            md: 4,
                            lg: 4,
                            xl: 4,
                        }}
                    >
                        <TextField
                            label={t('general.shippingListNo')}
                            multiline={true}
                            rows={10}
                            onChange={(event: any) => {
                                setShippingListNos(event.target.value);
                            }}
                            value={shippingListNos}
                            slotProps={{
                                inputLabel: {
                                    shrink: true,
                                },
                            }}
                            sx={{ marginBottom: 1, width: 250 }}
                        />
                        <div style={{ display: 'flex', gap: '20px', marginTop: '10px' }}>
                            <div style={{ position: 'relative', zIndex: 3 }}>
                                <SCUIButton
                                    text={t('general.clear')}
                                    type="error"
                                    buttonType="submit"
                                    sizeType="default"
                                    size="m"
                                    style={{ width: 110, borderRadius: '4px' }}
                                    startIcon={<DeleteIcon style={{ color: '#ffffff' }} />}
                                    onClick={() => {
                                        setShippingListNos('');
                                    }}
                                />
                            </div>
                            <div style={{ position: 'relative', zIndex: 2 }}>
                                <SCUIButton
                                    text={t('general.search')}
                                    type="primary"
                                    buttonType="submit"
                                    sizeType="default"
                                    size="m"
                                    style={{ width: 110, borderRadius: '4px' }}
                                    startIcon={<SearchIcon style={{ color: '#ffffff' }} />}
                                    onClick={() => SendToGoal(shippingListNos)}
                                />
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </Grid>
        </SCUIContent>
    );
};
